import CtaVerticalChecklistBoxes from './ctaVerticalChecklistBoxes';

export default CtaVerticalChecklistBoxes;
